class ResponseError extends Error {
  response: Response;

  constructor(response: Response) {
    super(`${response.status} | ${response.url} | ${response.type}`);
    this.response = response;
  }
}

export const throwIfNotOk = (responsePromise: Promise<Response>) => {
  return responsePromise.then((response) => {
    if (!response.ok) {
      throw new ResponseError(response);
    }

    return response;
  });
};

export const isResponseError = (error: unknown): error is ResponseError =>
  error instanceof ResponseError;
